// Design tokens for report pages (Plus / Orange / T-Mobile etc.)
// Mirrors docs/designs/kam-dashboard-1/project/tokens.jsx (Standard variant).
// Light theme only — dark mode wired but not exposed yet.

export const T = {
  light: {
    bg: '#fafaf9',
    bgSub: '#f5f5f4',
    surface: '#ffffff',
    surfaceSub: '#f9f9f7',
    border: 'rgba(0,0,0,0.08)',
    borderStrong: 'rgba(0,0,0,0.14)',
    text: '#1c1917',
    textSub: '#57534e',
    textDim: '#8a827a',
    accent: '#4f46e5',
    accentSub: '#eef2ff',
    good: '#16a34a',
    warn: '#d97706',
    bad: '#dc2626',
    goodSub: '#dcfce7',
    warnSub: '#fef3c7',
    badSub: '#fee2e2',
  },
  dark: {
    bg: '#0a0a0a',
    bgSub: '#111111',
    surface: '#141414',
    surfaceSub: '#1a1a1a',
    border: 'rgba(255,255,255,0.08)',
    borderStrong: 'rgba(255,255,255,0.16)',
    text: '#fafaf9',
    textSub: '#a8a29e',
    textDim: '#6b6460',
    accent: '#818cf8',
    accentSub: 'rgba(129,140,248,0.12)',
    good: '#22c55e',
    warn: '#f59e0b',
    bad: '#ef4444',
    goodSub: 'rgba(34,197,94,0.14)',
    warnSub: 'rgba(245,158,11,0.14)',
    badSub: 'rgba(239,68,68,0.14)',
  },
  op: {
    plus: { c: '#00a651', name: 'Plus' },
    orange: { c: '#ff7900', name: 'Orange' },
    play: { c: '#7b2cbf', name: 'Play' },
    tmobile: { c: '#e20074', name: 'T-Mobile' },
  },
  fontUI: '"Inter Tight", "Inter", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
  fontMono: '"JetBrains Mono", "SF Mono", ui-monospace, Menlo, monospace',
}

// Default theme (we render light only for now — no theme switcher exposed).
export const theme = T.light

// Number formatters — Polish locale.
export const fmt = {
  int: (n) => new Intl.NumberFormat('pl-PL').format(Math.round(n ?? 0)),
  pct: (n) => (Number(n) || 0).toFixed(1).replace('.', ',') + '%',
  pctShort: (n) => Math.round(n ?? 0) + '%',
  pln: (n) => new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 0 }).format(Math.round(n ?? 0)) + ' zł',
}

// Inject the Inter Tight + JetBrains Mono fonts once on first import.
// Idempotent: if already present we skip.
let _fontsInjected = false
export const ensureFonts = () => {
  if (_fontsInjected || typeof document === 'undefined') return
  _fontsInjected = true
  if (!document.querySelector('link[data-report-shell-fonts]')) {
    const pre1 = document.createElement('link')
    pre1.rel = 'preconnect'
    pre1.href = 'https://fonts.googleapis.com'
    document.head.appendChild(pre1)
    const pre2 = document.createElement('link')
    pre2.rel = 'preconnect'
    pre2.href = 'https://fonts.gstatic.com'
    pre2.crossOrigin = 'anonymous'
    document.head.appendChild(pre2)
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.dataset.reportShellFonts = '1'
    link.href = 'https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap'
    document.head.appendChild(link)
  }
}
